import gql from 'graphql-tag';

export default {
    isHandleAvailable: gql`
        query IsHandleAvailable($handle: String!) {
            isHandleAvailable(handle: $handle) {
                isAvailable
            }
        }
    `,
};
